import React, { useEffect, useState } from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';

const ActionButtons = ({ isFull, isBookmarked, chatRoomUrl, onApply, onToggleBookmark }) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="fixed bottom-0 left-0 right-0 z-sticky bg-card border-t border-border shadow-elevation-3 md:relative md:border-0 md:shadow-none">
        <div
          className="flex items-center gap-3 p-4 max-w-7xl mx-auto"
          style={{ paddingBottom: 'env(safe-area-inset-bottom, 16px)' }}
        >
          <div className="flex-1 h-14 rounded-lg bg-muted animate-pulse" />
        </div>
      </div>
    );
  }

  const handleChatRoom = () => {
    if (typeof window !== 'undefined') {
      window.open(chatRoomUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-sticky bg-card border-t border-border shadow-elevation-3 md:relative md:border-0 md:shadow-none">
      <div
        className="flex items-center gap-3 p-4 max-w-7xl mx-auto"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 16px)' }}
      >
        <button
          onClick={onToggleBookmark}
          className="flex items-center justify-center w-14 h-14 rounded-lg border border-border bg-background hover:bg-muted transition-smooth touch-target"
          aria-label={isBookmarked ? '북마크 해제' : '북마크 추가'}
          type="button"
        >
          <Icon
            name="BookmarkIcon"
            variant={isBookmarked ? 'solid' : 'outline'}
            size={24}
            className={isBookmarked ? 'text-primary' : 'text-muted-foreground'}
          />
        </button>

        <button
          onClick={handleChatRoom}
          className="flex items-center justify-center gap-2 px-6 h-14 rounded-lg border border-border bg-background text-foreground hover:bg-muted transition-smooth touch-target font-medium"
          type="button"
        >
          <Icon name="ChatBubbleLeftRightIcon" size={20} />
          <span className="hidden sm:inline">오픈채팅</span>
        </button>

        <button
          onClick={onApply}
          className={`flex-1 flex items-center justify-center gap-2 px-6 h-14 rounded-lg font-semibold transition-smooth touch-target active:scale-97 ${
            isFull
              ? 'bg-warning text-warning-foreground hover:shadow-elevation-2'
              : 'bg-primary text-primary-foreground hover:shadow-elevation-2'
          }`}
          type="button"
        >
          <Icon name={isFull ? 'ClockIcon' : 'CheckCircleIcon'} size={20} />
          {isFull ? '대기 신청' : '참가 신청'}
        </button>
      </div>
    </div>
  );
};

export default ActionButtons;
